import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(auth)/forgot-password/page.tsx");
